import styles from "./Impression.module.css";
import ImpressionKarte from "./ImpressionKarte/ImpressionKarte.jsx";

import impressionen1 from "../../assets/images/Impressionen/impressionen1.avif";
import impressionen2 from "../../assets/images/Impressionen/impressionen2.avif";
import impressionen3 from "../../assets/images/Impressionen/impressionen3.avif";
import impressionen4 from "../../assets/images/Impressionen/impressionen4.avif";

function Impression() {
  return (
    <div className={styles.impressionWrapper}>
      <div className={styles.impressionContainer}>
        <ImpressionKarte
          title="Liebe am Gaumen!"
          body="Schöne Kreationen und frische Zutaten haben meine Aromenwelt bereichert. Ich freue mich über die liebevolle Präsentation."
          image={impressionen4}
        />
        <ImpressionKarte
          title="Erinnerungen für immer!"
          body="Einfache Rezepte bringen leckere Aromen auf den Tisch. Im Gedächtnis bleibt die angenehme Aufmachung jeder Speise."
          image={impressionen1}
        />
        <ImpressionKarte
          title="Genuss im Herzen!"
          body="Die Köstlichkeiten haben mich beeindruckt. Frische Zutaten und leichte Noten harmonieren gut. Die Präsentation kam bei allen an."
          image={impressionen3}
        />
        <ImpressionKarte
          title="Hochzeitsglück schmeckt!"
          body="Jeder Bissen war angenehm. Farbenfrohe Gerichte und passende Gewürze sorgen für Genuss. Die Anrichte wirkt ansprechend."
          image={impressionen2}
        />
      </div>
    </div>
  );
}

export default Impression;
